export const cmsDataUrlByEnvironmentMap = {
    production: 'https://cdn.m2.ru/assets/cms-data',
    test: 'https://cdn.m2.ru/assets/cms-data-test',
    development: 'https://cdn.m2.ru/assets/cms-data-dev',
    perf: 'https://cdn.m2.ru/assets/cms-data-test',
    stage: 'https://cdn.m2.ru/assets/cms-data',
};
//# sourceMappingURL=cms-data-url-by-environment-map.js.map